<template>
<div id="c-content" class="c-content">

  <div v-if="usuarioLogado" class="rounded-lg c-content__principal">
    <div class="c-content__display">
        <Menu :dadosUser="dadosUser" />
    </div>
  </div>

  <v-container v-else class="c-content__login fill-height">
    <v-fade-transition appear>
    <v-row class="d-flex flex-column justify-center align-center" >
      <v-col>
        <login :sessaoExpirada="sessaoExpirada" />
      </v-col>
    </v-row>
    </v-fade-transition>
  </v-container>
  </div>
</template>

<script>
import Menu from "./Menu";
import login from "../usuario/login";

export default {
  name: "Content",
  components: { Menu, login },
  props:{
    usuarioLogado: Boolean,
    sessaoExpirada: Boolean,
    dadosUser: { type: Object, default: () => ({}) },
  },
};
</script>

<style>
#c-content {
  overflow: hidden;
}
.c-content__principal {
  margin: 0 2%;
  min-width: 320px;
  height: 100%;
  overflow: hidden;
}
.c-content__display {
  background: #fcfcfc;
  border-radius: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
